import * as types from './mutation-types'

export default {
  [types.ADD_SMTP](state, data) {
    state.smtp = data
  },
  
}
